import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlockCarModalContactComponent } from './block-car-modal-contact.component';
import { ModalModule } from "../../../../ui_modal/Modal.module";
import { PickCarContactModule } from "../pick-car-contact/pick-car-contact.module";
import { BtnModule } from "../../../../ui_button/btn.module";
import { PickCarInformationsModule } from "../pick-car-informations/pick-car-informations.module";

@NgModule({
    declarations: [BlockCarModalContactComponent],
    exports: [
        BlockCarModalContactComponent
    ],
    imports: [
        CommonModule,
        ModalModule,
        PickCarContactModule,
        BtnModule,
        PickCarInformationsModule
    ]
})
export class BlockCarModalContactModule {
}
